import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PublicSEO from '../../components/public/PublicSEO';
import { toast } from 'react-toastify';
import api from '../../services/api';
import { COMPANY, COMPANY_MAILTO } from '../../config/company';
import { buildBreadcrumb, buildContactPage } from '../../utils/jsonLd';
import { Checkbox } from '../../components/ui';
import './ContattiPage.css';

const ContattiPage = () => {
  const [form, setForm] = useState({
    fullName: '',
    email: '',
    telefono: '',
    message: '',
    privacy: false,
  });
  const [sending, setSending] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.privacy) {
      toast.error('Devi accettare la Privacy Policy per inviare la richiesta.');
      return;
    }
    setSending(true);
    try {
      const { data } = await api.post('/contatti', {
        fullName: form.fullName,
        email: form.email,
        telefono: form.telefono,
        message: form.message,
      });
      const message = data?.data ?? data?.message ?? 'Richiesta inviata. Ti risponderemo nel più breve tempo possibile.';
      toast.success(message);
      setForm({ fullName: '', email: '', telefono: '', message: '', privacy: false });
    } catch (err) {
      const msg = err.response?.data?.error ?? err.response?.data?.message ?? 'Errore nell\'invio. Riprova o scrivici a info@casadicurasanpaolo.it';
      toast.error(msg);
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="contatti-page">
      <PublicSEO
        title="Contatti - Assistenza e Prenotazioni"
        description="Hai bisogno di aiuto o informazioni? Contatta Virtual Clinic per assistenza, prenotazioni e chiarimenti sui servizi di telemedicina. Risposta nel più breve tempo possibile."
        canonicalPath="/contatti"
        keywords="contatti virtual clinic, assistenza telemedicina, supporto, informazioni"
        ogImageAlt="Contatta Virtual Clinic per assistenza e informazioni"
        jsonLd={[
          buildContactPage({ canonicalPath: '/contatti', name: 'Contatti Virtual Clinic' }),
          buildBreadcrumb([
            { name: 'Home', path: '/' },
            { name: 'Contatti' },
          ]),
        ]}
      />
      <section className="contatti-section">
        <div className="container">
          <div className="contatti-header">
            <h1>Domande? parliamone</h1>
            <p className="contatti-intro">
              Scrivici per assistenza, prenotazioni o informazioni sul servizio. Rispondiamo nel più breve tempo possibile.
            </p>
          </div>

          <div className="contatti-layout">
          <address className="contatti-company">
              <strong>{COMPANY.legalName}</strong><br />
              {COMPANY.legalForm}<br />
              {COMPANY.streetAddress}<br />
              {COMPANY.postalCode} {COMPANY.city} – {COMPANY.region}<br />
              P.IVA {COMPANY.vatNumber}<br />
              Tel:{' '}
              {COMPANY.phones.map((phone, i) => (
                <React.Fragment key={phone}>
                  {i > 0 ? ' · ' : null}
                  <a href={`tel:${phone.replace(/\s/g, '')}`}>{phone}</a>
                </React.Fragment>
              ))}
              <br />
              Email: <a href={COMPANY_MAILTO}>{COMPANY.email}</a>
            </address>

          <form className="contatti-form" onSubmit={handleSubmit} noValidate>
            <div className="contatti-field">
              <label htmlFor="fullName">Nome e cognome</label>
              <input
                id="fullName"
                type="text"
                name="fullName"
                className="form-control"
                placeholder="Il tuo Nome e Cognome*"
                value={form.fullName}
                onChange={handleChange}
                required
              />
            </div>
            <div className="contatti-field">
              <label htmlFor="email">Indirizzo E-mail</label>
              <input
                id="email"
                type="email"
                name="email"
                className="form-control"
                placeholder="Indirizzo Email*"
                value={form.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="contatti-field">
              <label htmlFor="telefono">Telefono</label>
              <input
                id="telefono"
                type="tel"
                name="telefono"
                className="form-control"
                placeholder="Numero di telefono*"
                value={form.telefono}
                onChange={handleChange}
                required
              />
            </div>
            <div className="contatti-field">
              <label htmlFor="message">Descrivi nel dettaglio la tua richiesta</label>
              <textarea
                id="message"
                name="message"
                className="form-control"
                rows={6}
                placeholder="Vorrei chiarimenti per..."
                value={form.message}
                onChange={handleChange}
                required
              />
            </div>
            <div className="contatti-field contatti-privacy">
              <Checkbox
                name="privacy"
                checked={form.privacy}
                onChange={handleChange}
                required
                label={
                  <>
                    Ho letto e accetto la{' '}
                    <Link
                      to="/privacy"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                    >
                      Privacy Policy
                    </Link>
                    .
                  </>
                }
              />
            </div>
            <div className="contatti-actions">
              <button type="submit" className="vc-btn vc-btn-primary" disabled={sending}>
                {sending ? 'Invio in corso...' : 'Invia Richiesta'}
              </button>
            </div>
            <p className="contatti-notice">
              Usiamo i dati del modulo solo per risponderti. Per i dettagli consulta la{' '}
              <Link to="/privacy">Privacy Policy</Link>.
            </p>
          </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContattiPage;
